$(function() {
    var topNav = $('.header .top-nav');

    function changeHeaderHeight() {
        $('.header').css({ 'padding-top' : topNav.outerHeight() });
    }
    function addStickyClass() {
        setTimeout(changeHeaderHeight, 200);
        if(window.pageYOffset > (topNav.outerHeight() / 2) ) {
            topNav.addClass("sticky-notification");
        } else {
            topNav.removeClass("sticky-notification");
        }
    }

    setTimeout(changeHeaderHeight, 100);
    addStickyClass();

    window.onscroll = function () {
        addStickyClass();
    };
});